import axios from "axios";
import { API_URL } from "../constants";

/** The caller's own birthday: day and month only. `isVisible` lets colleagues see it in the news. */
export interface OwnBirthday {
  month: number;
  day: number;
  isVisible: boolean;
}

/** Sending both `month` and `day` as null removes the birthday. */
export type OwnBirthdayInput = OwnBirthday | { month: null; day: null };

// null = nothing saved yet
export const fetchOwnBirthday = async (): Promise<OwnBirthday | null> => {
  const response = await axios.get(`${API_URL}/me/birthday`);
  return response.data.birthday;
};

export const saveOwnBirthday = async (input: OwnBirthdayInput): Promise<OwnBirthday | null> => {
  const response = await axios.put(`${API_URL}/me/birthday`, input);
  return response.data.birthday;
};
